import { render } from "./LoadingCheckbox.vue?vue&type=template&id=6b1eec59"
import script from "./LoadingCheckbox.vue?vue&type=script&lang=js"
export * from "./LoadingCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__